export const BRAND = {
  name: "Concrete Insight UK Ltd",
  short: "Concrete Insight",
  strap: "Reinforcement Corrosion Diagnosis & Repair",
  founded: "2025",
  areaOfOperation: "Nationwide, United Kingdom",
  logoUrl: "https://customer-assets-jai6qajn.emergentagent.net/job_concrete-repair-uk/artifacts/jv67a676_ChatGPT%20Image%20Aug%2026%2C%202026%2C%2012_21_09%20PM.png",
  phone: "(+44) 0203 733 2108",
  phoneDial: "+442037332108",
  email: "info@concreteinsightuk.co.uk",
  address: {
    line1: "Drayton House, Drayton Lane",
    line2: "Chichester, West Sussex",
    postcode: "PO20 2EW",
  },
  hours: "Mon to Fri · 08:00 to 18:00",
};

export const IMG = {
  rebarCloseup: "https://customer-assets.emergentagent.com/job_concrete-repair-uk/artifacts/zncsuyd5_PXL_20250703_123032441.webp",
  spallCeiling: "https://customer-assets.emergentagent.com/job_concrete-repair-uk/artifacts/bhi4ccvw_PXL_20260514_073855337.webp",
  repairInProgress: "https://customer-assets.emergentagent.com/job_concrete-repair-uk/artifacts/6o32laq0_PXL_20260427_094858180.webp",
  surveyMarking: "https://customer-assets.emergentagent.com/job_concrete-repair-uk/artifacts/qtybglgb_PXL_20260415_120434487.webp",
};

export const SERVICES = [
  {
    id: "diagnostics",
    code: "01",
    title: "Structural Diagnostics",
    tagline: "Investigation & condition survey",
    body:
      "Detailed visual, hammer-tap and instrument surveys to identify delamination, spalling and cover loss. We map every affected area and grade its severity before any works commence.",
    bullets: ["Hammer & sounding surveys", "Cover meter & half-cell mapping", "Photographic defect registers"],
  },
  {
    id: "testing",
    code: "02",
    title: "Concrete Chemistry & Testing",
    tagline: "Establish the deterioration mechanism",
    body:
      "Core sampling and on-site testing to identify the mechanism at play, chloride ingress, carbonation, sulphate attack, ASR, or a combination. Sampling and laboratory work is scoped to answer the specific diagnostic question, so the specification follows the fact, not a guess.",
    bullets: [
      "pH indicator carbonation depth testing",
      "Chloride ion titration and profile analysis",
      "Sulphate content and BRE SD1 ground-water assessment",
      "Petrographic examination for ASR, ettringite and mix design",
      "Cover meter, half-cell potential and resistivity surveys",
    ],
  },
  {
    id: "corrosion",
    code: "03",
    title: "Reinforcement Corrosion Repair",
    tagline: "Break out · clean · treat · reinstate",
    body:
      "Concrete broken out to a minimum of 25 mm behind the bar. Rebar cleaned to SA 2½, treated with a zinc-rich passivating primer, then reinstated with a compliant repair mortar or micro-concrete.",
    bullets: ["Selective breakout with hydro/mechanical means", "Grit-blast cleaning to SA 2½", "EN 1504-3 R3/R4 repair mortars"],
  },
  {
    id: "spall",
    code: "04",
    title: "Concrete Spall & Patch Repair",
    tagline: "Reinstatement to profile",
    body:
      "From isolated soffit patches to running façade spalls, we form, prime and rebuild in appropriate repair concrete, feathered and finished to match the substrate.",
    bullets: ["Feathered edge & saw-cut perimeters", "Fibre-reinforced repair mortars", "Anti-carbonation coating options"],
  },
  {
    id: "cathodic",
    code: "05",
    title: "Cathodic Protection (Advisory)",
    tagline: "Long-term corrosion control",
    body:
      "Where chloride contamination is extensive, we advise on galvanic anode and impressed-current systems, working with specialist installers to protect the whole element long-term.",
    bullets: ["Galvanic sacrificial anodes", "Anode spacing & load calculations", "Cover-zone remediation"],
  },
  {
    id: "assessment",
    code: "06",
    title: "Structural Assessment & Reporting",
    tagline: "Reports contractors & engineers can use",
    body:
      "Structured reports with plans, defect registers, photographs, laboratory data and a costed repair schedule. Written to be read by consulting engineers, insurers and asset owners.",
    bullets: ["EN 1504 compliant methodology", "Costed scope of works", "Digital defect registers"],
  },
  {
    id: "crack-injection",
    code: "07",
    title: "Crack Injection",
    tagline: "Sealing structural and non-structural cracks",
    body:
      "Injection of low-viscosity epoxy or polyurethane resins into cracks to restore monolithic behaviour, block water ingress and prevent further deterioration. Product and viscosity chosen to match crack width, movement and environment.",
    bullets: [
      "Low-viscosity epoxy for structural, non-moving cracks (Nitofill LV)",
      "Flexible PU resin for wet or actively-leaking cracks (Nitofill TH)",
      "Port-and-seal method, pressure-injected to full depth",
    ],
  },
  {
    id: "crack-stitching",
    code: "08",
    title: "Crack Stitching & Helical Reinforcement",
    tagline: "Restraining movement across cracks",
    body:
      "Stainless-steel helical bars bonded into slots cut across a crack to restrain further movement and restore tensile capacity. Common on masonry-clad concrete, façades and structural walls where injection alone isn't sufficient.",
    bullets: [
      "Helifix HeliBar stainless steel helical bars",
      "Helifix HeliBond cementitious grout",
      "Discrete, low-disruption install — no wide-scale demolition",
    ],
  },
  {
    id: "protective-coatings",
    code: "09",
    title: "Protective Coatings",
    tagline: "Anti-carbonation, chloride-resistant & elastic systems",
    body:
      "Whole-element coatings applied after repair to extend service life. Specification matched to the deterioration mechanism: anti-carbonation for CO₂ ingress, chloride-resistant for coastal / de-icing salt exposure, or elastomeric to bridge dynamic cracking.",
    bullets: [
      "Dekguard S anti-carbonation coating (EN 1504-2)",
      "Dekguard S200 chloride & water resistant coating",
      "Dekguard Elastic crack-bridging coating for façades",
    ],
  },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Diagnose",
    desc: "Site survey, testing and defect mapping to prove the corrosion mechanism.",
  },
  {
    n: "02",
    title: "Break Out",
    desc: "Selective removal of unsound concrete to a minimum 25 mm behind the affected bar.",
  },
  {
    n: "03",
    title: "Clean & Treat",
    desc: "Rebar cleaned to bare metal, then coated with a zinc-rich passivating primer.",
  },
  {
    n: "04",
    title: "Rebuild",
    desc: "Reinstate with an EN 1504-3 compliant repair mortar, cured and finished to profile.",
  },
];

export const CASE_STUDIES = [
  {
    id: "cs-01",
    ref: "CI-0142",
    title: "Basement Beam, Reinforcement Corrosion Survey",
    location: "Sussex, UK",
    year: "2025",
    problem:
      "A structural beam within a residential basement showed localised spalling and rust staining. On close inspection sections of the main tensile reinforcement had lost significant cover, with visible corrosion along the bar.",
    solution:
      "Element inspected with hammer-tap and cover meter survey. Photographic defect register produced and the extent of delamination mapped. Corrosion mechanism assessed against cover, exposure and construction date to inform the repair strategy.",
    outcome:
      "Recommendation issued: breakout to 25 mm behind the affected bars, grit-blast to SA 2½, zinc-rich primer to reinforcement, and reinstatement in an EN 1504-3 R4 repair mortar. Costed scope of works provided to the client for approval.",
    image: "surveyMarking",
    tag: "Basement Beam · Survey",
  },
  {
    id: "cs-02",
    ref: "CI-0139",
    title: "Office Block Column, Diagnostic Investigation",
    location: "Kent, UK",
    year: "2025",
    problem:
      "A load-bearing column within a commercial office block presented with cracking and localised concrete loss. Initial breakout for inspection exposed heavily corroded main bar and stirrups within a narrow section, with cover to reinforcement below specification.",
    solution:
      "Investigative breakout in a small trial area to expose the reinforcement and assess bar condition. Cover measured and photographed. Corrosion pattern assessed to distinguish between generalised (carbonation) and localised (chloride) mechanisms.",
    outcome:
      "Findings reported to the client with a recommended repair strategy: temporary support during works, breakout around the affected reinforcement, cleaning and treatment of the bar, and reinstatement in a flowable R4 micro-concrete to restore cover.",
    image: "rebarCloseup",
    tag: "Office Column · Investigation",
  },
  {
    id: "cs-03",
    ref: "CI-0137",
    title: "Car Park Waffle Slab, Soffit Survey",
    location: "London, UK",
    year: "2025",
    problem:
      "Extensive soffit spalling and delamination across the waffle-slab soffit of a car park deck. Multiple ribs affected, with exposed and visibly corroded bottom-steel across a substantial area, driven by chloride ingress from de-icing salts.",
    solution:
      "Deck soffit surveyed rib-by-rib with hammer-tap, cover meter and photographic capture. Extent of delamination mapped onto a plan and severity graded. Chloride profile assessed to confirm the corrosion mechanism.",
    outcome:
      "Recommended phased repair programme: breakout per affected rib, grit-blast and prime the reinforcement, reinstate in a fibre-reinforced repair mortar spray-applied and finished to the waffle profile. Anti-carbonation coating and galvanic anodes advised as part of the whole-element strategy.",
    image: "spallCeiling",
    tag: "Car Park · Waffle Slab Survey",
  },
  {
    id: "cs-04",
    ref: "CI-0128",
    title: "Office Block Slab Soffit, Defect Survey",
    location: "United Kingdom",
    year: "2025",
    problem:
      "Slab soffit within an office block showed a series of isolated spalls with visibly corroded reinforcement. Historic water ingress from a floor above had driven long-term corrosion of the bottom mat across several locations.",
    solution:
      "Soffit surveyed and each affected patch measured, photographed and logged onto a defect register. Extent of delamination mapped. Recommendation prepared for phased remediation to allow occupied use to continue.",
    outcome:
      "Client received a full defect register with photographs, extent of works and a costed repair specification. Recommended R3 trowel-applied mortar reinstatement with feathered edges to allow a paint-ready finish once complete.",
    image: "repairInProgress",
    tag: "Office Slab · Defect Survey",
  },
];

export const PROJECT_TYPES = [
  "Car Park / Deck",
  "Bridge / Highway Structure",
  "Balcony / Façade",
  "Basement / Substructure",
  "Industrial / Warehouse",
  "Marine / Coastal",
  "Other / Not Sure",
];

// ---------- Deterioration Mechanisms ----------
export const MECHANISMS = [
  {
    slug: "chloride-attack",
    code: "M01",
    name: "Chloride Attack",
    tagline: "Salt-driven corrosion of embedded steel",
    hero: "rebarCloseup",
    illustration: "/mech_chloride-attack.png",
    headline: "Chloride ions break the passive layer around embedded steel, and once they do, corrosion runs.",
    what:
      "Chloride ions (from marine environments, de-icing salts, or contaminated aggregates in older concrete) migrate through the concrete cover until they reach the reinforcement. Above a critical concentration, they destroy the natural alkaline passive film that protects the steel, and corrosion accelerates rapidly.",
    causes: [
      "Marine and coastal exposure (splash and spray zones)",
      "De-icing salts on car park decks and bridge structures",
      "Chloride-contaminated aggregates in older (pre-1977) concrete",
      "Industrial chloride process contamination",
    ],
    symptoms: [
      "Localised rust staining and cracking along the line of reinforcement",
      "Spalling of concrete cover with exposed corroded bars",
      "Delamination detected by hammer-tap survey",
      "Pitting corrosion of the reinforcement itself",
    ],
    diagnosis: [
      "Cover surveys with a cover meter to establish depth to steel",
      "Half-cell potential mapping to locate active corrosion cells",
      "Core sampling with chloride ion titration to a profile",
      "Resistivity testing to gauge corrosion risk",
    ],
    repair:
      "Repair is a combination of removing the source and treating the mechanism. Chloride-contaminated concrete around the affected bar is broken out to a minimum of 25 mm behind the steel, the reinforcement is cleaned to bare metal (SA 2½) and primed with a zinc-rich passivating coating. The area is reinstated in an EN 1504-3 R4 repair mortar. For widespread contamination, galvanic or impressed-current cathodic protection is advised.",
    products: ["renderoc-hb45", "nitoprime-zincrich-plus", "dekguard-s"],
    related: ["cs-03"],
  },
  {
    slug: "carbonation",
    code: "M02",
    name: "Carbonation",
    tagline: "The slow drift of CO₂ into concrete",
    hero: "spallCeiling",
    illustration: "/mech_carbonation.png",
    headline: "Carbonation lowers the pH of concrete cover quietly, over decades, until the reinforcement starts to rust.",
    what:
      "Atmospheric carbon dioxide reacts with the calcium hydroxide in concrete, converting it to calcium carbonate and dropping the pH from ~13 to below 9. Once the carbonation front reaches the reinforcement, the passive film is lost and generalised corrosion begins.",
    causes: [
      "Age of the structure (carbonation depth grows with time)",
      "Low cover to reinforcement",
      "Porous or poorly compacted concrete",
      "Urban and industrial atmospheres with elevated CO₂",
    ],
    symptoms: [
      "Fine cracking along the line of reinforcement",
      "Uniform (not pitted) corrosion of embedded steel",
      "Rust staining bleeding through the surface",
      "Spalling of thin cover concrete",
    ],
    diagnosis: [
      "pH indicator spray on freshly exposed concrete to measure the carbonation front",
      "Depth-of-cover surveys to compare cover to carbonation depth",
      "Petrographic analysis if the mix design is unknown",
      "Half-cell potential mapping",
    ],
    repair:
      "Where the carbonation front has reached the steel, affected concrete is broken out, reinforcement is cleaned and treated, and the element reinstated in a compliant repair mortar. Critically, an anti-carbonation coating (e.g. Dekguard S) is then applied to the whole element to arrest further CO₂ ingress and protect the cover zone from further deterioration.",
    products: ["renderoc-hb45", "nitoprime-zincrich-plus", "dekguard-s"],
    related: ["cs-01", "cs-04"],
  },
  {
    slug: "alkali-silica-reaction",
    code: "M03",
    name: "Alkali-Silica Reaction (ASR)",
    tagline: "Concrete cancer, an internal chemistry problem",
    hero: "surveyMarking",
    illustration: "/mech_alkali-silica-reaction.png",
    headline: "Reactive aggregates and alkalis form an expansive gel inside the concrete, cracking it from the inside out.",
    what:
      "Certain silica-bearing aggregates react with alkalis in the cement paste, forming a hygroscopic gel. The gel absorbs moisture, expands, and generates internal tensile stresses well in excess of the concrete's tensile strength, producing characteristic map cracking, expansion and long-term loss of durability.",
    causes: [
      "Reactive aggregates (opal, cristobalite, strained quartz, some cherts)",
      "High-alkali cement or alkali-releasing exposure",
      "Persistent moisture (structure needs water to sustain the reaction)",
      "Older UK concrete where reactive aggregate sources were not screened",
    ],
    symptoms: [
      "'Map' cracking (a random polygonal pattern) on exposed surfaces",
      "Gel exudation from cracks (translucent, brown-tinted)",
      "Expansion of the element, closing joints or bowing",
      "Pop-outs over individual reactive aggregate particles",
    ],
    diagnosis: [
      "Petrographic examination of cores under polarised-light microscopy to identify reactive aggregate and gel",
      "Expansion monitoring, pip gauges, DEMEC studs over months",
      "Moisture content monitoring (ASR requires ~80% internal RH)",
      "Structural review of load paths given loss of tensile capacity",
    ],
    repair:
      "ASR is a bulk chemistry problem, it cannot simply be patched out. Strategy focuses on removing moisture ingress (waterproofing, drainage), monitoring expansion, restraining the element where necessary, and in advanced cases replacing affected sections. Surface treatments to reduce moisture (silane impregnation) are commonly specified as part of the mitigation package.",
    products: ["dekguard-elastic", "renderoc-hb45"],
    related: [],
  },
  {
    slug: "sulphate-attack",
    code: "M04",
    name: "Sulphate Attack",
    tagline: "Expansion, softening and loss of strength",
    hero: "surveyMarking",
    illustration: "/mech_sulphate-attack.png",
    headline: "Sulphates react with cement hydration products to form expansive minerals, swelling and destroying the concrete.",
    what:
      "Sulphates in ground water, industrial effluent or contaminated soil react with the calcium hydroxide and calcium aluminate hydrates in Portland cement, forming gypsum and expansive ettringite. The result is progressive expansion, cracking, softening and eventual disintegration of the concrete.",
    causes: [
      "Sulphate-bearing ground water (particularly on brownfield and industrial sites)",
      "Pyrite oxidation in fill material generating sulphates in situ",
      "Sea-water contact",
      "Delayed Ettringite Formation (DEF) in concrete cast at high temperature",
    ],
    symptoms: [
      "Softening and 'sugaring' of the concrete surface",
      "Expansion, cracks with white efflorescence at the edges",
      "Loss of aggregate-paste bond visible on broken faces",
      "Concrete progressively losing strength on core testing",
    ],
    diagnosis: [
      "Chemical analysis of the concrete for sulphate content",
      "Analysis of ground water sulphate class (BRE SD1 / BS 8500)",
      "Petrographic examination for ettringite and gypsum crystals",
      "Compressive strength testing on cores to quantify strength loss",
    ],
    repair:
      "Sulphate attack is typically bulk deterioration rather than localised. Options range from replacing badly affected concrete with a sulphate-resistant mix (SRC or CEM III), applying a physical barrier to prevent further sulphate contact, and treating the source (drainage, soil replacement). Repair mortars must be sulphate-resistant grade to survive the environment.",
    products: ["renderoc-hb45", "dekguard-s"],
    related: [],
  },
  {
    slug: "fire-damage",
    code: "M05",
    name: "Fire Damage",
    tagline: "Post-fire structural assessment & repair",
    hero: "repairInProgress",
    illustration: "/mech_fire-damage.png",
    headline: "Concrete looks tough, but sustained fire alters its microstructure and reduces its capacity permanently.",
    what:
      "Above ~300 °C the calcium hydroxide in hardened concrete begins to break down; above ~500 °C compressive strength is significantly and permanently reduced; and reinforcement loses yield strength that only partially recovers on cooling. A methodical post-fire assessment is essential before an element can be recommissioned.",
    causes: [
      "Building fires, office, residential, industrial",
      "Vehicle fires in car parks",
      "Industrial and process fires",
      "Deliberate acts",
    ],
    symptoms: [
      "Colour change (pink 300 to 600 °C, whitish-grey 600 to 950 °C) indicating temperature reached",
      "Spalling, explosive or progressive, exposing reinforcement",
      "Cracking, particularly along reinforcement lines",
      "Sooting, softening of surfaces, loss of section",
    ],
    diagnosis: [
      "Post-fire visual and colour survey to estimate temperature contours",
      "Ultrasonic pulse velocity to assess depth of damaged concrete",
      "Core sampling for residual compressive strength",
      "Cover surveys and reinforcement testing where accessible",
    ],
    repair:
      "Damaged concrete is broken out to sound material, often to a considerable depth. Reinforcement is inspected and, where yield strength is compromised, supplemented or replaced. The element is reinstated in a repair mortar appropriate to the load duty. Where structural capacity is materially reduced, strengthening (plate bonding, FRP wrap or additional bars) is designed in as part of the reinstatement.",
    products: ["renderoc-hb45", "nitoprime-zincrich-plus", "nitomortar-s"],
    related: [],
  },
];

// ---------- Recommended Fosroc Products ----------
// Data curated from Fosroc technical datasheets. Illustrations courtesy of Fosroc International Ltd.
// All Fosroc trademarks belong to Fosroc International Ltd.
const FOSROC_IMG = {
  cementitious: "https://www.fosroc.com/assets/productDetailImages/028-Large-Fosroc-Cementitious-Repair.jpg",
  epoxy: "https://www.fosroc.com/assets/productDetailImages/029-Large-Fosroc-Epoxy-Repair.jpg",
  corrosion: "https://www.fosroc.com/assets/productDetailImages/039-Large-Fosroc-corrosion-protection.jpg",
  coating: "https://www.fosroc.com/assets/productDetailImages/041-Large-Fosroc-External-Protective-Coating.jpg",
};

export const PRODUCTS = [
  {
    slug: "renderoc-hb45",
    code: "P01",
    brand: "Fosroc",
    name: "Renderoc HB45",
    category: "Structural Repair Mortar",
    tagline: "High-strength, fibre-reinforced hand-applied repair mortar",
    image: FOSROC_IMG.cementitious,
    fosrocUrl: "https://www.fosroc.com/product/show/renderoc-hb45",
    summary:
      "A polymer-modified, fibre-reinforced, high-build cementitious mortar for reinstating reinforced concrete. Our default choice for columns, beams and soffits where an R4 structural repair is required.",
    spec: [
      { k: "Standard", v: "BS EN 1504-3 · Class R4" },
      { k: "Compressive strength", v: "> 45 MPa (50 MPa @ 28 days)" },
      { k: "Bond strength (pull-off)", v: "> 2.0 MPa" },
      { k: "Application thickness", v: "10 to 80 mm (vertical) · 10 to 70 mm (overhead) in a single layer" },
      { k: "Application method", v: "Hand-applied or wet-sprayed" },
      { k: "Packaging", v: "25 kg bag · ~1.4 m² per bag at 10 mm" },
    ],
    when: [
      "Reinstating spalled or broken-out concrete on structural elements",
      "Overhead soffit repairs where a high-build vertical mortar is needed",
      "Column and beam patch repairs following reinforcement treatment",
    ],
  },
  {
    slug: "nitoprime-zincrich-plus",
    code: "P02",
    brand: "Fosroc",
    name: "Nitoprime Zincrich Plus",
    category: "Reinforcement Primer",
    tagline: "Single-component zinc-rich epoxy primer for exposed reinforcement",
    image: FOSROC_IMG.corrosion,
    fosrocUrl: "https://www.fosroc.com/product/show/nitoprime-zincrich-plus",
    summary:
      "A single-pack zinc-rich epoxy primer applied to reinforcement after cleaning to SA 2½. Provides active galvanic protection and passivates the steel prior to reinstatement.",
    spec: [
      { k: "Standard", v: "BS EN 1504-7 · Method 11.1" },
      { k: "Type", v: "Single-component metallic zinc-rich epoxy" },
      { k: "Recommended DFT", v: "40 microns per coat (100 microns wet)" },
      { k: "Coverage", v: "~8 m² per litre" },
      { k: "Touch-dry / overcoat", v: "1 hour / 2 hours @ 20 °C" },
      { k: "Packaging", v: "800 mL and 1.9 L" },
    ],
    when: [
      "Priming exposed reinforcement immediately after grit-blast cleaning",
      "Every corrosion repair prior to reinstatement in a Renderoc mortar",
      "Where a fire-safety-compliant reinforcement primer is required (LU Standard 1-085)",
    ],
  },
  {
    slug: "dekguard-s",
    code: "P03",
    brand: "Fosroc",
    name: "Dekguard S",
    category: "Anti-Carbonation Coating",
    tagline: "Protective coating against CO₂, chlorides and moisture",
    image: FOSROC_IMG.coating,
    fosrocUrl: "https://www.fosroc.com/product/show/dekguard-s",
    summary:
      "A protective coating applied to the whole element after repair. Provides a barrier to atmospheric CO₂ (arresting further carbonation) and to chloride ingress. Part of the Renderoc repair system.",
    spec: [
      { k: "Standard", v: "BS EN 1504-2 · Principles 1.3, 2.2, 8.2" },
      { k: "Protects against", v: "CO₂, chloride ions, oxygen, water" },
      { k: "Substrates", v: "New and repaired reinforced concrete" },
      { k: "Finish", v: "Matt · pigmented" },
    ],
    when: [
      "After completing carbonation-driven repairs, applied to the whole element",
      "Marine and coastal structures at risk of further chloride ingress",
      "Extending the service life of car park decks and façades post-repair",
    ],
  },
  {
    slug: "dekguard-elastic",
    code: "P04",
    brand: "Fosroc",
    name: "Dekguard Elastic",
    category: "Crack-Bridging Coating",
    tagline: "Elastomeric coating that accommodates future movement",
    image: FOSROC_IMG.coating,
    fosrocUrl: "https://www.fosroc.com/product/show/dekguard-elastic",
    summary:
      "A crack-bridging elastomeric acrylic coating for elements where further movement or hairline cracking is expected. Common on ASR-affected structures being monitored, and on façades with a history of thermal cracking.",
    spec: [
      { k: "Type", v: "Elastomeric acrylic protective coating" },
      { k: "Elongation", v: "High, bridges dynamic cracks" },
      { k: "Colour", v: "Available in a range of pigmented finishes" },
      { k: "Use with", v: "Nitoprime DG primer (silane-siloxane)" },
    ],
    when: [
      "ASR-affected structures under expansion monitoring",
      "Façades and elements with ongoing thermal or shrinkage cracking",
      "Where a decorative, colour-matched finish is required over the repair",
    ],
  },
  {
    slug: "nitomortar-s",
    code: "P05",
    brand: "Fosroc",
    name: "Nitomortar S",
    category: "Structural Epoxy Mortar",
    tagline: "High-strength epoxy repair for severe or thin-section reinstatement",
    image: FOSROC_IMG.epoxy,
    fosrocUrl: "https://www.fosroc.com/product/show/nitomortar-s",
    summary:
      "A three-component epoxy resin mortar for high-strength, chemically resistant reinstatement. Selected where a cementitious repair is inappropriate, thin sections, harsh chemical exposure, or where early strength is critical.",
    spec: [
      { k: "Type", v: "Solvent-free epoxy resin mortar" },
      { k: "Compressive strength", v: "Very high, > 70 MPa typical" },
      { k: "Chemical resistance", v: "Excellent (acids, alkalis, hydrocarbons)" },
      { k: "Application", v: "Trowel-applied, thin to moderate sections" },
    ],
    when: [
      "Chemical process areas where acid/alkali exposure is expected",
      "Thin-section repairs where a cementitious mortar would fail",
      "Post-fire repairs where high early strength is required",
    ],
  },
  {
    slug: "renderoc-rg",
    code: "P06",
    brand: "Fosroc",
    name: "Renderoc RG (LA)",
    category: "Flowable Micro-Concrete",
    tagline: "Non-shrink micro-concrete for congested reinforcement",
    image: FOSROC_IMG.cementitious,
    fosrocUrl: "https://www.fosroc.com/product/show/renderoc-rg",
    summary:
      "A high-strength, free-flowing micro-concrete for reinstating structural elements where placement space is restricted or the reinforcement is congested. Poured into formwork rather than trowelled.",
    spec: [
      { k: "Standard", v: "BS EN 1504-3 · Class R4" },
      { k: "Type", v: "Cementitious, non-shrink, flowable micro-concrete" },
      { k: "Application", v: "Poured into formwork; ideal for full-section reinstatement" },
      { k: "Best for", v: "Column encasement, deep pockets, congested rebar" },
    ],
    when: [
      "Full-section column or beam reinstatement",
      "Where hand-applied mortar cannot reach behind reinforcement",
      "Larger-volume placements requiring flow around dense bar arrangements",
    ],
  },
  {
    slug: "nitofill-lv",
    code: "P07",
    brand: "Fosroc",
    name: "Nitofill LV",
    category: "Crack Injection Resin",
    tagline: "Low-viscosity epoxy for structural crack injection",
    image: FOSROC_IMG.epoxy,
    fosrocUrl: "https://www.fosroc.com/product/show/nitofill-lv",
    summary:
      "A two-part, low-viscosity epoxy resin for pressure-injection into fine structural cracks. Restores monolithic behaviour by bonding both faces of the crack and blocking water ingress.",
    spec: [
      { k: "Standard", v: "BS EN 1504-5" },
      { k: "Type", v: "Two-part, solvent-free epoxy" },
      { k: "Viscosity", v: "Low — penetrates cracks from ~0.2 mm" },
      { k: "Compressive strength", v: "> 60 MPa" },
      { k: "Application", v: "Port-and-seal pressure injection" },
    ],
    when: [
      "Fine, non-moving structural cracks in concrete",
      "Restoring monolithic behaviour after cracking",
      "Beams, columns and slabs where crack sealing alone isn't enough",
    ],
  },
  {
    slug: "nitofill-th",
    code: "P08",
    brand: "Fosroc",
    name: "Nitofill TH",
    category: "Crack Injection Resin",
    tagline: "Thixotropic polyurethane for wet or moving cracks",
    image: FOSROC_IMG.epoxy,
    fosrocUrl: "https://www.fosroc.com/product/show/nitofill-th",
    summary:
      "A flexible polyurethane injection resin for cracks that are wet, actively leaking, or subject to minor thermal or shrinkage movement. Reacts on contact with water to form a tough, flexible seal.",
    spec: [
      { k: "Standard", v: "BS EN 1504-5" },
      { k: "Type", v: "Single-part polyurethane, water-reactive" },
      { k: "Behaviour", v: "Flexible seal, accommodates minor movement" },
      { k: "Application", v: "Port-and-seal pressure injection" },
    ],
    when: [
      "Wet or actively-leaking cracks",
      "Basement or substructure water ingress",
      "Cracks with residual thermal or shrinkage movement",
    ],
  },
  {
    slug: "helifix-helibar",
    code: "P09",
    brand: "Helifix",
    name: "HeliBar",
    category: "Helical Reinforcement Bar",
    tagline: "Stainless steel helical bar for crack stitching",
    image: FOSROC_IMG.corrosion,
    fosrocUrl: "https://www.helifix.co.uk/products/helibar/",
    summary:
      "A high-tensile stainless steel helical bar bonded into pre-cut slots across a crack, restoring tensile capacity and restraining further movement. Standard product for façade and wall crack stitching.",
    spec: [
      { k: "Material", v: "Austenitic stainless steel (Grade 304 or 316)" },
      { k: "Diameters", v: "6 mm, 8 mm, 10 mm nominal" },
      { k: "Tensile strength", v: "> 1,100 N/mm²" },
      { k: "Installation", v: "Bonded into cut slots with Helifix HeliBond grout" },
    ],
    when: [
      "Crack stitching across masonry or concrete walls",
      "Restraining diagonal or vertical structural cracks",
      "Discrete, low-disruption reinforcement of façades and lintels",
    ],
  },
  {
    slug: "dekguard-s200",
    code: "P10",
    brand: "Fosroc",
    name: "Dekguard S200",
    category: "Chloride-Resistant Coating",
    tagline: "Marine-grade coating for chloride exposure",
    image: FOSROC_IMG.coating,
    fosrocUrl: "https://www.fosroc.com/product/show/dekguard-s200",
    summary:
      "A high-build acrylic protective coating with enhanced resistance to chloride ion penetration. Specified on coastal, marine and de-icing-salt-exposed structures where a standard anti-carbonation coating isn't enough.",
    spec: [
      { k: "Standard", v: "BS EN 1504-2 · Principles 1.3, 2.2, 8.2" },
      { k: "Protects against", v: "Chlorides, CO₂, water ingress" },
      { k: "Finish", v: "Matt, pigmented" },
      { k: "Substrates", v: "Concrete in marine and coastal environments" },
    ],
    when: [
      "Coastal balconies, marine structures, harbour walls",
      "Car park decks exposed to de-icing salt run-off",
      "Whole-element protection where chloride ingress is the primary risk",
    ],
  },
];

export const PRODUCTS_BY_SLUG = PRODUCTS.reduce((acc, p) => {
  acc[p.slug] = p;
  return acc;
}, {});

export const MECHANISMS_BY_SLUG = MECHANISMS.reduce((acc, m) => {
  acc[m.slug] = m;
  return acc;
}, {});
